// extracted by mini-css-extract-plugin
export default {"staggerIn":"SelectionSprig_staggerIn__THBZd","staggerInOptions":"SelectionSprig_staggerInOptions__8O2Ev","animationOutNotSelected":"SelectionSprig_animationOutNotSelected__z7KFD"};